import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ContentVideo } from 'modules/trainings/components/content/items/shared/fields/ContentVideo'
import { InlineEditableTitle } from 'modules/trainings/components/content/items/shared/fields/InlineEditableTitle'
import { titleStyle } from 'modules/trainings/components/content/styles.vanilla.css'
import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { VideoBlock } from 'modules/trainings/lib/content/VideoBlock'

export const VideoBlockView = observer(
  ({ contentItem, onContentChange }: ContentEditorProps<VideoBlock>) => {
    const { id: trainingId } = useParams()

    const handleTitleChange = (value: string) => {
      contentItem.title = value
      onContentChange()
    }

    const handleVideoChange = (video: AttachedFile) => {
      contentItem.video = video
      onContentChange()
    }

    const handleVideoDelete = () => {
      contentItem.video.clear()
      onContentChange()
    }

    return (
      <Box gap="s24" width="full" alignItems="center">
        <InlineEditableTitle
          value={contentItem.title}
          placeholder={i18n.t('trainings.content.block.video.title_placeholder')}
          ariaLabel={i18n.t('trainings.content.block.video.title_label')}
          onChange={handleTitleChange}
          style={titleStyle}
        />

        <ContentVideo
          video={contentItem.video}
          readOnly={false}
          trainingId={String(trainingId)}
          description={i18n.t('trainings.content.block.video.upload_file_description')}
          onChange={handleVideoChange}
          onDelete={handleVideoDelete}
        />
      </Box>
    )
  }
)
